import React from 'react';
import { Link } from 'react-router-dom';

import useStyles from './styles';

type LinkProps =
    | {
          to: string;
          href?: never;
      }
    | {
          to?: never;
          href: string;
      };

type BaseProps = {
    title: React.ReactNode;
    className?: string;
};

type Props = BaseProps & LinkProps;

const Item: React.FC<Props> = ({ title, to, href, className }) => {
    const { classes, cx } = useStyles();
    const Component: React.ElementType = href ? 'a' : Link;
    const props = href ? { href, target: '_blank', rel: 'noopener noreferrer' } : { to };
    return (
        <Component {...props} className={cx(classes.root, className)}>
            {title}
        </Component>
    );
};

export default Item;
